export default {
  makeQueryParamForRails(query) {
    let params = '?'
    if (Object.keys(query).length > 0) {
      params += Object.entries(query).map(([key, value]) => {
        if (value) {
          if (Array.isArray(value)){
            return value.map(v => `q[${key}][]=${v}`).join('&')
          } else {
            return `q[${key}]=${value}`
          }
        } else {
          return null
        }
      }).filter(v => v).join('&')
    }
    return params
  },
  compareObject(obj1, obj2) {
    return JSON.stringify(objectSort(obj1)) === JSON.stringify(objectSort(obj2))
  },
  objectSort(obj) {
    return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {})
  },
  modifyInvalidTagsAndCharacters(content) {
    let result = content.replace(/<font color="/g, '<span style="color: ')
    result = result.replace(/<font/g, '<span')
    result = result.replace(/<\/font>/g, '</span>')
    result = result.replace(//g, '') //tiptap 버그로 인해 삽입되는 BS 문자 삭제
    return result
  },
  getSubstringDistance(targetString, subString) {
    let distance = -1;
    let prevIdx = -1;

    const lowerCaseTargetString = targetString.toLowerCase()
    const lowerCaseSubString = subString.toLowerCase()

    for (const char of lowerCaseSubString) {
      const idx = lowerCaseTargetString.indexOf(char, prevIdx + 1)

      if (lowerCaseSubString.length === 1) {
        return idx
      }

      if (idx > prevIdx) {
        if (prevIdx !== -1) {
          distance += (idx - prevIdx)
        }
        prevIdx = idx
      } else {
        return -1
      }
    }

    return distance
  },
  snakeToPascal(str) {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
  },
  pascalToSnake(str) {
    return str.replace(/[\w]([A-Z])/g, function(m) {
      return m[0] + "_" + m[1];
    }).toLowerCase();
  },
  arrayAverage(arr) {
    return (arr.reduce((p, c) => p + c, 0) / arr.length)
  },
  stringShortener(text, maxLength) {
    if (text === null || text === undefined) {
      return text
    }
    if (text.length > maxLength){
      return text.substring(0, maxLength) + "..."
    }
    return text
  },
  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  },
  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  async fetch(path,  method = 'GET', bodyObject = null) {
    let csrfElement = document.querySelector("meta[name=csrf-token]");
    const csrfToken = csrfElement && csrfElement.content;
    let headers = { Accept: 'application/json', 'X-CSRF-Token': csrfToken, 'Content-Type': 'application/json' }
    let body = bodyObject ? JSON.stringify(bodyObject) : null
    let result = await fetch(path, { headers, method, body })
    if (result.status === 404) {
      return { status: 404 }
    }

    return parseJsonResponse(result)
  }
}

async function parseJsonResponse(result) {
  const status = result.status
  if (status === 204) {
    return { status }
  }

  const contentType = result.headers?.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    return { status }
  }

  try {
    return await result.json()
  } catch (error) {
    return { status, error: 'invalid_json' }
  }
}
function objectSort(obj) {
  return Object.keys(obj).sort().reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {})
}
